import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M3 8.12L5.12 6L12 12.88L18.88 6L21 8.12L12 17.12L3 8.12Z" fill="currentColor"/>
  </svg>

)
